import React, { useEffect } from 'react';
import { Card, CardContent, Container, Typography, Button } from '@mui/material';
import { Link } from 'react-router-dom';

export const Home = () => {
  useEffect(() => {
    document.title = "Home - Pest Control Raipur Services";
  }, []);

  return (
    <Container>
      <Card variant="outlined" sx={{ mt: 4, p: 3, textAlign: 'center' }}>
        <CardContent>
          <Typography variant="h4" gutterBottom>Welcome to Pest Control Raipur Services</Typography>
          <Typography variant="body1">
            Providing professional pest control solutions for homes and businesses in Raipur, Chhattisgarh. Our team of experts is dedicated to ensuring a pest-free environment for you and your loved ones.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/services" sx={{ mt: 2 }}>
            View Our Services
          </Button>
        </CardContent>
      </Card>
      <Card variant="outlined" sx={{ mt: 4, p: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>Why Choose Us?</Typography>
          <Typography variant="body1">
            At Pest Control Raipur Services, we prioritize your safety and satisfaction. Our services are tailored to meet your specific needs, using eco-friendly products and the latest techniques to effectively manage pests.
          </Typography>
          <Typography variant="body1">
            Our team is highly trained and certified, ensuring that you receive the best possible service. We offer a wide range of pest control solutions, including termite treatment, cockroach control, rodent control, bed bug treatment, and more.
          </Typography>
        </CardContent>
      </Card>
      <Card variant="outlined" sx={{ mt: 4, p: 3 }}>
        <CardContent>
          <Typography variant="h5" gutterBottom>Contact Us</Typography>
          <Typography variant="body1">
            Have a pest problem? Contact us today to schedule a consultation and get a quote. Our team is ready to assist you with all your pest control needs.
          </Typography>
          <Button variant="contained" color="primary" component={Link} to="/contact" sx={{ mt: 2 }}>
            Get in Touch
          </Button>
        </CardContent>
      </Card>
    </Container>
  );
};